import { AllLevelRestrictionStore } from "./Variable"
import { RestrictionTypeEnum } from "../../../../../../Wrap/Constants/Enums/RestrictionTypeEnum"
import { ProcessType } from "../../../../../Shared/IST/Resource/Content";
import { RestrictionReasonTypeEnum } from "../../../../../../Wrap/Constants/Enums/RestrictionReasonTypeEnum";

export const useRestrictionActivitiesHook = () => {

    const returnSuspendedActivities = (headClAccountId: string, subClAccountId?: string) => {
        const activityAccountRestrictions = AllLevelRestrictionStore.getData();
        if (!activityAccountRestrictions || activityAccountRestrictions.length === 0) {
            return [];
        }
        let suspendedProcessTypes: ProcessType[] = []
        activityAccountRestrictions.filter(restriction => restriction.ClAccountId === headClAccountId || restriction.ClAccountId === subClAccountId).forEach(restriction => {
            switch (restriction.Restriction) {
                case RestrictionTypeEnum.PensionActivities:
                    suspendedProcessTypes = suspendedProcessTypes.concat([
                        ProcessType.TakePensionBenefits,
                        ProcessType.TopUpWithITFLS,
                        ProcessType.EditIncomeDrawdown,
                        ProcessType.CancelRegularCrystallisation,
                        ProcessType.OneoffIncomePayments,
                        ProcessType.ConvertCappedToFlexi,
                        ProcessType.GadReview,
                        ProcessType.EditIncome
                    ])
                    break;
            }
        });
        return suspendedProcessTypes;
    }

    const isBlockedByPensionProcessingRestriction = (headClAccountId: string, subClAccountId?: string) => {
        const activityAccountRestrictions = AllLevelRestrictionStore.getData().filter(restriction => restriction.ClAccountId === headClAccountId || restriction.ClAccountId === subClAccountId);
        if (!activityAccountRestrictions || activityAccountRestrictions.length === 0) {
            return false;
        }
        
        return activityAccountRestrictions.some(restriction => 
            restriction.Restriction === RestrictionTypeEnum.PensionActivities &&
            restriction.RestrictionReason === RestrictionReasonTypeEnum.PensionProcessing
        );
    }

    const isPensionActivitiesBeenSuspended = (headClAccountId: string, subClAccountId?: string) => {
        const activityAccountRestrictions = AllLevelRestrictionStore.getData().filter(restriction => restriction.ClAccountId === headClAccountId || restriction.ClAccountId === subClAccountId);
        if (!activityAccountRestrictions || activityAccountRestrictions.length === 0) {
            return false;
        }
        
        return activityAccountRestrictions.some(restriction => 
            restriction.Restriction === RestrictionTypeEnum.PensionActivities
        );
    }

    return {
        isPensionActivitiesBeenSuspended,
        returnSuspendedActivities,
        isBlockedByPensionProcessingRestriction
    };
}
